import { useEffect, useState, type ReactNode } from 'react';

const productUrl =
  'https://sunndelabs.com/products/sunnde-labs-copper-peptide-infusion-kit-for-hair-regrowth';

const reasons = [
  {
    number: '01',
    kicker: 'DEEP SCALP DELIVERY',
    title: 'It Actually Delivers the Formula Where Hair Loss Happens',
    image: '/assets/reasons/01-deep-scalp-delivery.png',
    alt: 'Scientific illustration showing blue serum delivered through micro-channels beneath the scalp toward hair follicles',
    paragraphs: [
      'Most hair loss products sit on top of your scalp and hope for the best. Sunnde Labs uses a micro-infusion stamp to create hundreds of micro-channels directly into the scalp, then floods those channels with our Copper Peptide Serum the moment they open.',
      'That means the active ingredients go exactly where dormant follicles live, not just the surface of your hair. This is why topical serums alone rarely work, and why this system does.',
    ],
  },
  {
    number: '02',
    kicker: 'STOP HAIR LOSS AT THE SOURCE',
    title: 'It Targets the Root Cause of Hair Loss at the Source',
    image: '/assets/reasons/02-dht-follicle-comparison.jpg',
    alt: 'Scientific comparison showing DHT around a shrinking follicle and targeted support around a healthier follicle',
    paragraphs: [
      "DHT is the hormone responsible for shrinking your hair follicles over time until they stop producing hair entirely. Most products ignore it. Sunnde Labs doesn't.",
      'Our serum contains Licorice Root Extract, Caffeine, and Ginseng Root Extract which are all clinically studied botanicals that blocks DHT at the follicle level, stopping the shrinkage cycle before it can continue. No prescription. No systemic interference with your hormones. Just targeted action, right where it counts.',
    ],
  },
  {
    number: '03',
    kicker: 'REAL RESULTS, REAL PEOPLE',
    title: 'Real Men. Real Hair. Real Results.',
    image: '/assets/reasons/03-customer-results-reviews.png',
    alt: 'Two Sunnde Labs customer before-and-after hair comparisons with their six-week and three-month reviews',
    paragraphs: [
      "We let our customers do the talking. In as little as 6 weeks, men are reporting visible changes. By 3 to 4 months, the difference is hard to ignore. The customer in the top review said it “worked like a miracle” and that after three months the results were “absolutely fantastic.” The customer in the bottom review said he saw results in 6 weeks and calls the applicator one of the easiest he's ever used.",
      "These aren't filtered, paid testimonials. These are people who were skeptical, tried it, and came back to tell others. The before and after photos you see on this page are from real Sunnde Labs customers.",
    ],
  },
  {
    number: '04',
    kicker: 'NO HIDDEN COSTS',
    title: "Drugs Come With a Cost Most Men Aren't Told About",
    image: '/assets/reasons/04-treatment-comparison.png',
    alt: 'Scientific comparison of finasteride systemic exposure, topical minoxidil side effects, and localized Sunnde micro-infusion scalp delivery',
    paragraphs: [
      'Finasteride, works by altering your hormone levels systemically. For a significant number of men that means sexual dysfunction, loss of libido, erectile dysfunction, depression, and brain fog, side effects that for some men persist long after they stop taking the drug. Minoxidil comes with its own list: scalp irritation, unwanted facial hair growth, heart palpitations, and a brutal shedding phase when you stop.',
      "Sunnde Labs delivers results without touching your hormones, without a prescription, and without any of that. You shouldn't have to choose between your hair and your health.",
    ],
  },
  {
    number: '05',
    kicker: 'THE QUALITY DIFFERENCE',
    title: 'Not All Copper Peptides Are Created Equal',
    image: '/assets/reasons/05-copper-peptide-quality-comparison.jpg',
    alt: 'Mass-produced generic serum compared with precisely measured high-grade copper peptides in a laboratory',
    paragraphs: [
      'Copper peptides are one of the most studied actives in hair and skin science. They stimulate hair follicle growth, extend the growth phase of the hair cycle, and support collagen production around the follicle. But the results you get depend entirely on quality and delivery.',
      "Sunnde Labs uses high-grade copper peptides formulated specifically for scalp absorption, and delivers them through micro-channels opened by the stamp, so they reach the follicle instead of evaporating off the top layer of skin. You're not just buying copper peptides. You're buying copper peptides that actually get in.",
    ],
  },
  {
    number: '06',
    kicker: 'STAY IN GROWTH MODE',
    title: 'Most Hair Never Gets the Chance to Fully Grow. This Fixes That.',
    image: '/assets/reasons/06-active-growth-phase.jpg',
    alt: 'Scientific illustration showing blood flowing toward and nourishing an active hair follicle',
    paragraphs: [
      "Hair growth happens in cycles. The problem for men with thinning hair isn't just that follicles shrink. It's that hair is spending less and less time in the active growth phase before it sheds. Sunnde Labs includes L-Arginine in the serum specifically to address this.",
      'Arginine is a precursor to nitric oxide, which increases blood flow to the scalp and signals follicles to stay in the growth phase longer. More time growing. Less time resting. More hair on your head.',
    ],
  },
  {
    number: '07',
    kicker: 'RISK-FREE TRIAL',
    title: "Try It for 150 Days. If It Doesn't Work, You Pay Nothing.",
    image: '/assets/reasons/07-150-day-guarantee.png',
    alt: 'Sunnde Labs vial and micro-infusion device beside a 150-day money-back guarantee',
    paragraphs: [
      "We offer the longest money-back guarantee in the category because we built this product to actually work. 150 days. Five full months. If you follow the protocol once a week and don't see results, contact us and we will refund every dollar.",
      'No hoops. No fine print. No questions designed to talk you out of it. The only risk here is staying where you are.',
    ],
  },
];

const surveyResults = [
  ['87%', 'reported visibly thicker, healthier-looking hair in areas that had been thinning months before.'],
  ['91%', 'said it was the easiest, non-greasy scalp treatment they had ever used.'],
  ['78%', 'reported that their shedding stopped within the first month.'],
  ['96%', 'found the Sunnde Labs Infusion Kit completely painless.'],
];

const customerReviews = [
  {
    title: 'Easy to Use, Never Greasy',
    body: 'I’ve been using this hair regrowth system for a little while and so far I’m happy with it. It’s easy to use, doesn’t feel greasy, and absorbs pretty quickly. I’ve noticed my hair feels a bit stronger and healthier.',
    name: 'Michael S.',
  },
  {
    title: 'New Growth Around Week Five',
    body: 'This product really works you just have to stay consistent with it before seeing any growth results. Around my fifth week, I can feel some new stubbles in some new areas, on my head.',
    name: 'David K.',
  },
  {
    title: 'Real Progress Over Time',
    body: 'It works! It wasnt overnight or anything crazy but over time I started seeing real progress in the areas I was using it on. After a few weeks I could tell something was happening and that was enough for me to stick with it.',
    name: 'Anthony C.',
  },
  {
    title: 'Baby Hairs Started Coming In',
    body: 'I have only been using it for a few weeks and baby hairs have started to come in. Biggest thing I would say is consistency and making sure you’re living a healthy lifestyle. I recommend it a lot.',
    name: 'Thomas P.',
  },
];

const ratingBreakdown = [
  { stars: 5, percentage: 86 },
  { stars: 4, percentage: 14 },
  { stars: 3, percentage: 0 },
  { stars: 2, percentage: 0 },
  { stars: 1, percentage: 0 },
];

const imageReviews = [
  {
    name: 'Jack Y.',
    location: 'New York City, NY',
    rating: 5,
    image: '/assets/customer-reviews/jack-y.png',
    alt: 'Jack Y. before and after photos showing fuller-looking hair across the top of the scalp',
    body: 'I’ve been fighting with hair loss for years now but I finally found the perfect solution the before and after is just amazing how much hair I have now compared to three months ago five starts for sure!!!!',
  },
  {
    name: 'Gabe T.',
    location: 'Long Beach, CA',
    rating: 5,
    image: '/assets/customer-reviews/gabe-t.png',
    alt: 'Gabe T. before and after photos showing fuller-looking hair at the crown',
    body: "Wow! It really does work! I started using the product only 3 months ago and you can see the difference! I'm shocked how well it works!",
  },
  {
    name: 'Riley V.',
    location: 'Milwaukee, WI',
    rating: 5,
    image: '/assets/customer-reviews/riley-v.png',
    alt: 'Riley V. before and after close-up photos showing fuller-looking hair at the crown',
    body: 'It works! It wasnt overnight or anything crazy but over time I started seeing real progress in the areas I was using it on. After a few weeks I could already tell something was happening. This is me after 4 months of use.',
  },
  {
    name: 'Greg A.',
    location: 'Akron, OH',
    rating: 5,
    image: '/assets/customer-reviews/greg-a.png',
    alt: 'Greg A. before and after photos showing fuller-looking hair across the top of the scalp',
    body: 'Ordered the 3 month supply, 2 months later after applying it once a week I saw a major improvement! Can’t wait to see the results after month 3!',
  },
];

const heroResultSlides = [
  {
    src: '/assets/hero-results/result-01.png',
    alt: 'Customer before and after comparison showing fuller-looking hair across the front and crown',
  },
  {
    src: '/assets/hero-results/result-02.png',
    alt: 'Customer before and after comparison showing fuller-looking hair across the top of the scalp',
  },
  {
    src: '/assets/hero-results/result-03.png',
    alt: 'Customer before and after comparison showing improved-looking coverage at the crown and hairline',
  },
  {
    src: '/assets/hero-results/result-04.png',
    alt: 'Customer before and after comparison showing fuller-looking hair around the crown',
  },
  {
    src: '/assets/hero-results/result-05.png',
    alt: 'Customer before and after comparison showing improved-looking density across the top of the scalp',
  },
  {
    src: '/assets/hero-results/result-06.png',
    alt: 'Customer before and after comparison showing fuller-looking coverage at the crown',
  },
];

function HeroResultsSlider() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateAnimationState = () => {
      if (motionPreference.matches) {
        setIsTransitioning(false);
        setActiveIndex(0);
      } else if (document.hidden) {
        setActiveIndex((currentIndex) => {
          if (currentIndex === heroResultSlides.length) {
            setIsTransitioning(false);
            return 0;
          }

          return currentIndex;
        });
      }

      setShouldAnimate(!motionPreference.matches && !document.hidden);
    };

    updateAnimationState();
    motionPreference.addEventListener('change', updateAnimationState);
    document.addEventListener('visibilitychange', updateAnimationState);

    return () => {
      motionPreference.removeEventListener('change', updateAnimationState);
      document.removeEventListener('visibilitychange', updateAnimationState);
    };
  }, []);

  useEffect(() => {
    heroResultSlides.slice(1).forEach(({ src }) => {
      const image = new Image();
      image.src = src;
    });
  }, []);

  useEffect(() => {
    if (!shouldAnimate) return undefined;

    const timer = window.setInterval(() => {
      setIsTransitioning(true);
      setActiveIndex((currentIndex) => currentIndex + 1);
    }, 3000);

    return () => window.clearInterval(timer);
  }, [shouldAnimate]);

  const finishTransition = () => {
    if (activeIndex === heroResultSlides.length) {
      setIsTransitioning(false);
      setActiveIndex(0);
    }
  };

  const slides = [...heroResultSlides, heroResultSlides[0]];
  const visibleSlide = activeIndex % heroResultSlides.length;

  return (
    <div
      className="hero-slider"
      role="region"
      aria-roledescription="carousel"
      aria-label="Sunnde Labs customer before-and-after results"
      aria-live="off"
    >
      <div
        className={`hero-slider-track${isTransitioning ? '' : ' hero-slider-track-static'}`}
        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        onTransitionEnd={finishTransition}
      >
        {slides.map((slide, index) => {
          const isClonedSlide = index === heroResultSlides.length;

          return (
            <div
              className="hero-slide"
              aria-hidden={isClonedSlide || index !== visibleSlide}
              key={`${slide.src}-${index}`}
            >
              <img
                src={slide.src}
                alt={isClonedSlide ? '' : slide.alt}
                loading={index === 0 ? 'eager' : 'lazy'}
                decoding={index === 0 ? 'sync' : 'async'}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

function OfferButton({ children = 'SAVE 35% + GET FREE GIFTS' }: { children?: ReactNode }) {
  return <a className="cta" href={productUrl}>{children} <span aria-hidden="true">→</span></a>;
}

function getTimeUntilMidnight() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);

  const totalSeconds = Math.max(0, Math.floor((midnight.getTime() - now.getTime()) / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  };
}

function GrowthOfferSection() {
  const [timeRemaining, setTimeRemaining] = useState(getTimeUntilMidnight);

  useEffect(() => {
    const updateCountdown = () => setTimeRemaining(getTimeUntilMidnight());
    updateCountdown();
    const intervalId = window.setInterval(updateCountdown, 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <section className="growth-offer section-pad" aria-labelledby="growth-offer-heading">
      <div className="growth-offer-intro">
        <h2 id="growth-offer-heading">Thinning Hair&apos;s Real Problem: Treatments That Never Reach the Follicle</h2>
        <p>Copper peptides, Licorice Root Extract, and Ginseng Root Extract delivered directly into the scalp through micro-infusion, bypassing the surface barrier that makes every serum and shampoo you&apos;ve tried fail. For men who are done guessing.</p>
      </div>

      <div className="growth-offer-card">
        <div className="growth-offer-media">
          <img
            src="/assets/offers/microinfusion-kit-offer.png"
            alt="Sunnde Labs Copper Peptide Infusion Kit with nine serum vials, six microneedle heads, and three infusion devices"
            loading="lazy"
          />
        </div>

        <div className="growth-offer-copy">
          <h3>SAVE 35% ON YOUR FIRST PURCHASE</h3>
          <p className="growth-offer-description">Save on your first purchase and receive free gifts while supplies last.</p>

          <div
            className="growth-offer-countdown"
            role="timer"
            aria-label={`Offer ends in ${timeRemaining.hours} hours, ${timeRemaining.minutes} minutes, and ${timeRemaining.seconds} seconds`}
          >
            <span className="growth-offer-countdown-label">OFFER ENDS IN</span>
            <div className="growth-offer-time" aria-hidden="true">
              {([
                ['hours', timeRemaining.hours],
                ['minutes', timeRemaining.minutes],
                ['seconds', timeRemaining.seconds],
              ] as const).map(([label, value]) => (
                <div className="growth-offer-time-unit" key={label}>
                  <strong>{value}</strong>
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="growth-offer-trust" aria-label="Offer benefits">
            <span>Sell-Out Risk: <strong>High</strong></span>
            <span>FREE GIFTS INCLUDED</span>
          </div>

          <OfferButton>GET 35% OFF + FREE GIFTS</OfferButton>
          <p className="cta-note">Try it today with a 150-Day Money Back Guarantee!</p>
        </div>
      </div>
    </section>
  );
}

export default function App() {
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="announcement">SAVE 35% ON YOUR FIRST PURCHASE · FREE GIFTS INCLUDED</div>
      <header className="site-header">
        <a href="#top" aria-label="Sunnde Labs home"><img src="/assets/logo.png" alt="Sunnde Labs" /></a>
        <a className="header-link" href={productUrl}>Save 35% + free gifts</a>
      </header>

      <main id="main-content">
        <section className="hero" id="top">
          <div className="hero-media">
            <HeroResultsSlider />
          </div>
          <div className="hero-copy">
            <h1>7 Reasons Men With Thinning Hair Are Switching to Sunnde Labs</h1>
            <p className="hero-deck">The prescription isn't the best option anymore.</p>
            <div className="rating" aria-label="Rated 4.8 out of 5 based on 7,235 reviews"><span aria-hidden="true">★★★★★</span><strong>4.8/5</strong><span>Based on 7,235 reviews</span></div>
            <ul className="hero-points"><li>Powered by Copper Tripeptide-1</li><li>Use only 3 times per month</li><li>150-day money-back guarantee</li></ul>
            <OfferButton />
            <p className="cta-note">Free gifts included · 150-day money-back guarantee</p>
          </div>
        </section>

        <section className="reasons" aria-label="Seven reasons men are switching to Sunnde Labs">
          {reasons.map((reason, index) => (
            <article className={`reason-row ${index % 2 ? 'reason-row-reverse' : ''}`} key={reason.number}>
              <div className="reason-media"><img src={reason.image} alt={reason.alt} loading="lazy" /></div>
              <div className="reason-copy">
                <div className="reason-kicker"><span>{reason.kicker}</span><strong>{reason.number}</strong></div>
                <h2>{reason.title}</h2>
                {reason.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              </div>
            </article>
          ))}
        </section>

        <GrowthOfferSection />

        <section className="survey-results section-pad" aria-labelledby="survey-results-heading">
          <div className="survey-panel">
            <div className="survey-heading">
              <h2 id="survey-results-heading">What Users Are Saying.</h2>
              <p>Survey conducted after 12 weeks of using Sunnde Labs, based on responses from 1,200+ people.</p>
            </div>
            <dl className="survey-grid">
              {surveyResults.map(([percentage, result]) => (
                <div className="survey-stat" key={percentage}>
                  <dt>{percentage}</dt>
                  <dd>{result}</dd>
                </div>
              ))}
            </dl>
            <p className="survey-disclaimer">Self-reported survey responses. Individual results vary.</p>
          </div>
        </section>

        <section className="customer-reviews section-pad" aria-labelledby="customer-reviews-heading">
          <div className="section-heading review-heading">
            <h2 id="customer-reviews-heading">Their Progress, In Their Own Words.</h2>
          </div>
          <div className="review-grid">
            {customerReviews.map((review) => (
              <article className="review-card" key={review.name}>
                <div className="review-stars" aria-label="5 out of 5 stars">★★★★★</div>
                <h3>{review.title}</h3>
                <p>{review.body}</p>
                <footer>
                  <strong>{review.name}</strong>
                  <span className="verified-purchase"><span aria-hidden="true">✓</span>Verified Purchase</span>
                </footer>
              </article>
            ))}
          </div>
        </section>

        <section className="image-reviews section-pad" aria-labelledby="image-reviews-heading">
          <div className="image-reviews-inner">
            <h2 id="image-reviews-heading">Customer Reviews</h2>
            <div className="review-summary">
              <div className="review-score">
                <strong>4.8</strong>
                <div className="summary-stars" aria-label="Rated 4.8 out of 5 stars">★★★★★</div>
                <span>7,235 reviews</span>
              </div>
              <ol className="rating-breakdown" aria-label="Customer rating distribution">
                {ratingBreakdown.map(({ stars, percentage }) => (
                  <li key={stars}>
                    <span className="rating-bar" aria-hidden="true"><span style={{ width: `${percentage}%` }} /></span>
                    <span className="distribution-stars" aria-hidden="true"><span>{'★'.repeat(stars)}</span><span className="empty-stars">{'★'.repeat(5 - stars)}</span></span>
                    <span className="rating-percentage">{percentage}%</span>
                    <span className="sr-only">{percentage}% of reviews are {stars} star{stars === 1 ? '' : 's'}</span>
                  </li>
                ))}
              </ol>
            </div>
            <div className="image-review-list">
              {imageReviews.map((review) => (
                <article className="image-review-card" key={review.name}>
                  <img src={review.image} alt={review.alt} loading="lazy" />
                  <div className="image-review-copy">
                    <div className="image-review-stars" aria-label={`${review.rating} out of 5 stars`}>★★★★★</div>
                    <div className="image-review-meta">
                      <strong>{review.name} · {review.location}</strong>
                      <span className="verified-purchase"><span aria-hidden="true">✓</span>Verified Purchase</span>
                    </div>
                    <p>{review.body}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

      </main>

      <footer className="site-footer">
        <img src="/assets/logo.png" alt="Sunnde Labs" />
        <nav aria-label="Footer"><a href="https://sunndelabs.com/policies/shipping-policy">Shipping</a><a href="https://sunndelabs.com/policies/refund-policy">Refunds</a><a href="https://sunndelabs.com/policies/privacy-policy">Privacy</a><a href="https://sunndelabs.com/policies/terms-of-service">Terms</a><a href="https://sunndelabs.com/pages/contact">Contact</a></nav>
        <p>© 2026 Sunnde Labs. Results vary by individual.</p>
      </footer>

      <div className="mobile-offer"><div><strong>35% off first purchase</strong><span>Free gifts included</span></div><a href={productUrl}>GET OFFER →</a></div>
    </>
  );
}
